export default {"src":"/newStatic/_next/static/media/medium.37baab49.svg","height":20,"width":20};